import React from 'react'
import { i18n } from 'next-i18next'
import { Withdrawal } from 'src/core/models'
import { CustomTitle } from 'src/components'

const WithdrawalDateColumn: React.FC<{ withdrawal: Withdrawal }> = ({ withdrawal }) => {

  const getDateFormatted = () => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' } as const
    const date = new Date(withdrawal.created)
    return date.toLocaleString(i18n.language, options)
  }

  return <CustomTitle label={getDateFormatted()} type={null} className={'has-text-centered'} />
}

export default WithdrawalDateColumn
